module.exports = __webpack_public_path__ + "static/fighting-infernos-before-they-start-b6ec799716423869b58bfdfcf1644d9b.jpg";